import { render, staticRenderFns } from "./NodeRemoveButton.vue?vue&type=template&id=2293fb1e&scoped=true"
import script from "./NodeRemoveButton.vue?vue&type=script&lang=js"
export * from "./NodeRemoveButton.vue?vue&type=script&lang=js"
import style0 from "./NodeRemoveButton.vue?vue&type=style&index=0&id=2293fb1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293fb1e",
  null
  
)

export default component.exports